import { render, staticRenderFns } from "./ResendTokenSuccess.vue?vue&type=template&id=784155b1&scoped=true&"
import script from "./ResendTokenSuccess.vue?vue&type=script&lang=js&"
export * from "./ResendTokenSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ResendTokenSuccess.vue?vue&type=style&index=0&id=784155b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784155b1",
  null
  
)

export default component.exports